import { Route, Routes } from "react-router-dom";
import SecureRoute from "../Elements/SecureRoute";
import OpportunitiesList from "../Views/Opportunities/Opportunitylist";
import OpportunitiesAssesmentList from "../Views/Opportunities/OpportunityAssessmentlist";
import ManageOpportunity from "../Views/Opportunities/ManageOpportunity";
import AddOportunity from "../Views/Opportunities/AddOpportunity";
import OpportunityDetail from "../Views/Opportunities/OpportunityDetails";
import PositionDetails from "../Views/Opportunities/PositionDetails";

function OpportunityRoutes() {
  return (
    <Routes>
      <Route index element={<SecureRoute element={<OpportunitiesList />} />} />
      <Route
        index
        path="assesments"
        element={
          <SecureRoute
            level={["LCVP TM", "MCVP TM"]}
            element={<OpportunitiesAssesmentList />}
          />
        }
      />
      <Route
        path="manage/:id"
        element={
          <SecureRoute
            level={["LCVP TM", "MCVP TM"]}
            element={<ManageOpportunity />}
          />
        }
      />
      <Route
        path="add"
        element={
          <SecureRoute
            level={["LCVP TM", "MCVP TM"]}
            element={<AddOportunity />}
          />
        }
      />
      <Route
        path=":id"
        element={<SecureRoute element={<OpportunityDetail />} />}
      />
      <Route
        path=":id/:slotid"
        element={<SecureRoute element={<PositionDetails />} />}
      />
    </Routes>
  );
}
export default OpportunityRoutes;
